import { createSlice } from "@reduxjs/toolkit";
import authService from "services/authService";
import { setUserData } from "./userSlice";

export const submitRegister = (user, redirectUrl) => async (dispatch) => {
	try {
		dispatch(setSubmitting(true));
		const result = await authService.createUser(user);
		dispatch(setUserData(result, redirectUrl));
		dispatch(registerSuccess());
	} catch (error) {
		console.error(error);
		return dispatch(registerError(error));
	} finally {
		dispatch(setSubmitting(false));
	}
};

const initialState = {
	success: false,
	isSubmitting: false,
	errors: [],
};

const registerSlice = createSlice({
	name: "auth/register",
	initialState,
	reducers: {
		setSubmitting: (state, action) => {
			state.isSubmitting = action.payload;
		},
		registerSuccess: (state, action) => {
			state.success = true;
			state.errors = [];
		},
		registerError: (state, action) => {
			state.success = false;
			state.errors = action.payload;
		},
	},
	extraReducers: {},
});

export const {
	setSubmitting,
	registerSuccess,
	registerError,
} = registerSlice.actions;

export default registerSlice.reducer;
